import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { OrganizationService } from '../../services/organization/organization.service';
import { UserService } from '../../services/user/user.service';
import { OrderService } from '../../services/order/order.service';
import { InventoryService } from '../../services/inventory/inventory.service';

export type PreFetchEntity = 'user' | 'organization' | 'saleStats' | 'inventoryStats';

export const preFetchResolverFactory = (
  ...entities: PreFetchEntity[]
): Record<PreFetchEntity, ResolveFn<unknown>> => {
  const preFetchEntities: Record<PreFetchEntity, ResolveFn<unknown>> = {
    user: () => inject(UserService).getCurrentUser(),
    organization: () => inject(OrganizationService).getCurrentOrganization(),
    saleStats: () => inject(OrderService).getStats(),
    inventoryStats: () => inject(InventoryService).getStats(),
  };

  return entities.reduce(
    (acc, entity) => {
      acc[entity] = preFetchEntities[entity];
      return acc;
    },
    {} as Record<PreFetchEntity, ResolveFn<unknown>>,
  );
};
